import React from 'react';

import AwsConfig from '../awsConfig';

import InteractiveIcon from './InteractiveIcon';

import classes from './NavBar.module.css';

const NavBar = ({ children }) => (
    <div className={classes.navBar}>
        <div className={classes.navItems}>
            {children}
        </div>
        <div className={classes.simpoContainer}>
            <InteractiveIcon
                iconPath="/assets/images/simpoHelpIcon.svg"
                label="Help"
                className={classes.simpoButton}
                onClick={() => window.open(AwsConfig.key2act.helpUrl, '_blank')}
            />
        </div>
    </div>
);

export default NavBar;
